var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "GB") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M6.8502126,13.6866186 C3.12891228,13.6739883 0.116074534,10.6531568 0.116074534,6.92889441 C0.116074534,3.19662112 3.14156522,0.171130435 6.87363975,0.171130435 C10.605913,0.171130435 13.6314037,3.19662112 13.6314037,6.92889441 C13.6314037,10.6531568 10.618566,13.6739883 6.89706815,13.6866186 L6.8502126,13.6866186 L6.8502126,13.6866186 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "FICC",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Disclaimer---language-options",
    transform: "translate(-517.000000, -244.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Lang",
    transform: "translate(448.000000, 244.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "GB",
    transform: "translate(69.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16,8 C16,12.4182 12.4184,16 8,16 C3.5818,16 0,12.4182 0,8 C0,3.5816 3.5818,0 8,0 C12.4184,0 16,3.5816 16,8",
    id: "Fill-303",
    fill: "#336581"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-320",
    transform: "translate(1.142857, 1.142857)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-306"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-305",
    fill: "#FFFFFF",
    mask: "url(#mask-2)",
    points: "-3.06941615 13.6864596 16.6242981 13.6864596 16.6242981 0.170931677 -3.06941615 0.170931677"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-307",
    fill: "#BF111F",
    mask: "url(#mask-2)",
    points: "10.1172273 5.05764969 16.624159 0.772432298 16.624159 0.171190062 16.1749665 0.171190062 8.75533913 5.05764969"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-308",
    fill: "#BF111F",
    mask: "url(#mask-2)",
    points: "9.8093913 9.07182112 16.6241988 13.5575851 16.6241988 12.6605913 11.1712795 9.07182112"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-309",
    fill: "#BF111F",
    mask: "url(#mask-2)",
    points: "-3.06949565 1.20089441 2.75967205 5.05759006 4.12175901 5.05759006 -3.06949565 0.302310559"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-310",
    fill: "#BF111F",
    mask: "url(#mask-2)",
    points: "3.8136646 9.07182112 -3.06951553 13.6082683 -3.06951553 13.6865789 -1.82668323 13.6865789 5.17575155 9.07182112"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-311",
    fill: "#003F62",
    mask: "url(#mask-2)",
    points: "15.2771776 0.171090683 8.38167453 0.171090683 8.38167453 4.71509068"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-312",
    fill: "#003F62",
    mask: "url(#mask-2)",
    points: "5.33656646 0.171090683 -1.53111056 0.171090683 5.33656646 4.71509068"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-313",
    fill: "#003F62",
    mask: "url(#mask-2)",
    points: "16.6242186 5.05764969 16.6242186 1.95742609 11.9470509 5.05764969"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-314",
    fill: "#003F62",
    mask: "url(#mask-2)",
    points: "16.6242186 12.1382957 16.6242186 9.07186087 11.9470509 9.07186087"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-315",
    fill: "#003F62",
    mask: "url(#mask-2)",
    points: "-1.14130683 13.6865391 5.33660621 13.6865391 5.33660621 9.41523478"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-316",
    fill: "#003F62",
    mask: "url(#mask-2)",
    points: "8.38159503 13.6865391 14.8797814 13.6865391 8.38159503 9.41523478"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-317",
    fill: "#003F62",
    mask: "url(#mask-2)",
    points: "-3.06949565 9.07182112 -3.06949565 12.2765913 1.77105093 9.07182112"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-318",
    fill: "#003F62",
    mask: "url(#mask-2)",
    points: "-3.06949565 5.05764969 1.77105093 5.05764969 -3.06949565 1.8477118"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-319",
    fill: "#BF111F",
    mask: "url(#mask-2)",
    points: "5.94546087 0.171090683 5.94546087 5.86092919 -3.06939627 5.86092919 -3.06939627 8.26927702 5.94546087 8.26927702 5.94546087 13.6866186 7.77264099 13.6866186 7.77264099 8.26927702 16.624318 8.26927702 16.624318 5.86092919 7.77264099 5.86092919 7.77264099 0.171090683"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGb);
export default __webpack_public_path__ + "static/media/GB.2e9012f830b6b17e09fa4dbdf540d4ea.svg";
export { ForwardRef as ReactComponent };